import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import __ from '@vitafy/common-libraries/frontend/Translate';
import ReviewsList, { ReviewListMeta } from './ReviewsList';

import { LoadReviewsActionPayload } from '../redux/actions';
import Review from '../../server/domain/Review';
import { ReviewAppState } from '../redux/reducers';
import ReviewsSummary from './ReviewsSummary';
import { VotesDistribution } from '../../server/domain/ReviewSummary';

const App: React.FC<ReviewListMeta> = ({
  reviews,
  reviewsMap,
  reviewSummary,
  page,
  locale,
  totalPages,
  isLoading,
  limit,
  isBundle
}) => {
  // TODO: hacky way to check wether the review-form has been toggled-in outside of this app
  const listenToGlobalReviewFormCollapse = (ref: any) => {
    useEffect(() => {
      const handleOutsideClick = (event: Event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          if (!document.getElementById('review-form').hasAttribute('hidden')) {
            document
              .getElementById('review-summary-link--anchor')
              .setAttribute('style', 'display: inline-block;');
            document
              .getElementById('review-summary-link--collapsible')
              .setAttribute('style', 'display: none;');
          }
        }
      };
      if (typeof document !== 'undefined') {
        document.addEventListener('click', handleOutsideClick);
      }
      return () => {
        if (typeof document !== 'undefined') {
          document.removeEventListener('click', handleOutsideClick);
        }
      };
    }, [ref]);
  };

  const rootRef = useRef<HTMLDetailsElement>(null);
  listenToGlobalReviewFormCollapse(rootRef);

  return (
    <details
      id="reviews"
      className="accordion accordion--icon details details--pdp details--pdp-reviews"
      style={{ opacity: isLoading ? '.9' : '' }}
      ref={rootRef}
      data-average={reviewSummary.averageRating}
      data-total={reviewSummary.totalReviews}
    >
      <summary>
        <div className="accordion__header accordion__header--fixed">
          {reviewSummary.totalReviews > 0 && (
            <span>
              <span className="rating-box">
                <span className="rating" style={{ width: `${reviewSummary.averageRating * 20}%` }} />
              </span>
              &nbsp;
            </span>
          )}
          <h2 className="h3">
            {reviewSummary.totalReviews > 0 && `(${reviewSummary.totalReviews}) `}
            {__({ val: 'Ratings', locale })}
          </h2>
        </div>
      </summary>
      <div className="accordion__content">
        {reviewSummary.totalReviews > 0 && (
          <ReviewsSummary
            distribution={reviewSummary.distribution}
            averageRating={reviewSummary.averageRating}
            locale={locale}
          />
        )}

        {reviewSummary.totalReviews > 0 && (
          <ReviewsList
            reviews={[...reviews]}
            reviewsMap={reviewsMap}
            reviewSummary={reviewSummary}
            page={page}
            totalPages={totalPages}
            isLoading={isLoading}
            limit={limit}
            locale={locale}
            isBundle={isBundle}
          />
        )}

        {reviewSummary.totalReviews === 0 && (
          <article>
            <div>
              {__({ val: 'No reviews yet', locale })}.{' '}
              {__({ val: 'Be the first to rate this product!', locale })}
            </div>
          </article>
        )}
      </div>
    </details>
  );
};

const mapStateToProps = (state: ReviewAppState) => ({
  isLoading: state.isLoading,
  isBundle: state.isBundle,
  locale: state.locale,
  page: state.page,
  reviews: state.reviews.slice(0, state.limit), // slicing in order to prevent diff in reviews-list length between server and client
  reviewsMap: state.reviewsMap,
  totalPages: state.totalPages,
  limit: state.limit,
  reviewSummary: {
    averageRating: state.averageRating,
    totalReviews: state.allVotes,
    distribution: state.distribution
  }
});

interface StateFromProps {
  isLoading: boolean;
  isBundle: boolean;
  locale: string;
  page: number;
  reviews: Review[];
  reviewsMap: Map<number, Review[]>;
  reviewSummary?: {
    averageRating?: number;
    voteCount?: number;
    distribution?: any[] | VotesDistribution[];
  };
  totalPages: number;
}

interface DispatchFromProps {
  loadReviews: (payload: LoadReviewsActionPayload) => void;
}

export default connect<StateFromProps, DispatchFromProps>(mapStateToProps)(App);
